module.exports = __webpack_public_path__ + "static/White_Dragon-8ea1e15f0af04cfb3dde046fe276f5b6.jpg";